import React, { Component } from 'react';


import styled from 'styled-components';
import { colors } from '../utils/colors';

import Sw from './Sw';
import Grain from './Grain';


// STYLED
// const Block = styled.div`
//    background: ${colors.black};
// 	margin: 0 auto;
// 	max-width: 650px;
// 	padding-top: 2em;
// 	padding: 1em;
// `;
// const Center = styled.div`
//    background: ${colors.black};
// 	margin: 0 auto;
// 	text-align: center;
// 	padding-top: 2em;
// 	padding: 1em;
// `;

const Full = styled.div`
   background: ${colors.black};
	margin: 0 auto;
	text-align: center;
	position: relative;
`;


// COMPONENTE
class Desktop extends Component {
   state = {
      data: []
   };

   render() {
      return (
         <div style={{overflow: 'hidden'}}>
            <Grain width={this.props.width} height={this.props.height}/>

            <Full>
               <Sw width={this.props.width} height={this.props.height} />
            </Full>
         </div>
      );
   }
}

export default Desktop;



// WEBPACK FOOTER //
// ./src/components/Desktop.js